import { useContext, useEffect } from 'react'
import { ModalContext } from '@nv/contexts'
import { useTranslation } from 'react-i18next'

export const ImageModal = ({ image }: any) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  useEffect(() => {
    setHeaderLabel(t('registration.proofOfIdentity'))
    setBtns([
      {
        text: t('buttons.close'),
        onClick: () => onClose(),
      },
    ])
  }, [])

  return <img src={image} alt={t('auth.voterId')} />
}
